import { render } from "./CloudBanner.vue?vue&type=template&id=006561f8&scoped=true"
import script from "./CloudBanner.vue?vue&type=script&lang=js"
export * from "./CloudBanner.vue?vue&type=script&lang=js"

import "./CloudBanner.vue?vue&type=style&index=0&id=006561f8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006561f8"]])

export default __exports__